module.exports = __webpack_public_path__ + "img/sfz.c435e134.png";